import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/org/$organization/$project/$application/analytics/node/$applicationId/dependencies/')({
    component: ()=>null
});
